module.exports = __webpack_public_path__ + "img/cu.38be6eaf.svg";